import { Col, Container, Row } from "react-bootstrap";
import { useCallback, useEffect } from 'react';
import { RescuePlanPageTwo } from '../../../api';
import "./RescuePlanPageOne.css"
import LabelAndTextBox from "../../molecules/labelandtextbox/LabelAndTextBox";

interface RescuePlanPageTwoProps {
  rescuePlanPageTwo: RescuePlanPageTwo;
  onUpdate?: (updatedData: Partial<RescuePlanPageTwo>) => void;
}

const RescuePlanPageTwoSection: React.FC<RescuePlanPageTwoProps> = (props) => {
  const { onUpdate } = props;

  const handleChange = useCallback((updatedData: Partial<RescuePlanPageTwo>) => {
    onUpdate?.(updatedData);
  }, [onUpdate]);

  useEffect(() => {
    const signature = props.rescuePlanPageTwo?.signature?.trim();
    const nameClarification = props.rescuePlanPageTwo?.nameClarification?.trim();

    if (signature && nameClarification && signature === nameClarification) {
      handleChange({ signature: '' });
    }
  }, [handleChange, props.rescuePlanPageTwo?.signature, props.rescuePlanPageTwo?.nameClarification]);

  return (
    <Container className='align-items-center tablecolor'>
      <h4 className='fw-bold'>Räddningsplan:</h4>
      <Row><h5>Alla som genomför detta arbete skall vara införstådda med denna räddningsplan</h5></Row>
      <p className="rescuePlanInfoBox fs-5 p-2">Vid fara för liv, ring 112. Vid risk för hängtrauma, säkerställ att personen kan bli avlastad genom exempelvis räcka ut ett
        plank eller annat som kan avlasta. </p>
      <h4 className='mt-4 mb-4'>Räddningssätt:</h4>
      <Col xs={12} md={6} lg={12}>
        <div className='checkbox-container'>
          <div className='checkboxes'>
            <div className='checkbox-1'>
              <div className='checkbox-options'>
                <div className='checkbox-option'>
                  <input type="checkbox" name="conduct" defaultChecked={props.rescuePlanPageTwo?.rescueOptionsLift}
                    onChange={() => {
                      handleChange({ rescueOptionsLift: !props.rescuePlanPageTwo.rescueOptionsLift });
                    }} />
                  <label>Lift</label>
                </div>
                <div className='checkbox-option'>
                  <input type="checkbox" name="use" defaultChecked={props.rescuePlanPageTwo?.rescueOptionsCraneBasket}
                    onChange={() => {
                      handleChange({ rescueOptionsCraneBasket: !props.rescuePlanPageTwo.rescueOptionsCraneBasket });
                    }} />
                  <label>Krankorg</label>
                </div>
                <div className='checkbox-option'>
                  <input type="checkbox" name="dismantling" defaultChecked={props.rescuePlanPageTwo?.rescueOptionsRescueService}
                    onChange={() => {
                      handleChange({ rescueOptionsRescueService: !props.rescuePlanPageTwo.rescueOptionsRescueService });
                    }} />
                  <label>Räddningstjänst</label>
                </div>
                <div className='checkbox-option'>
                  <input type="checkbox" name="scaff" defaultChecked={props.rescuePlanPageTwo?.rescueOptionsEvacuationAndSafetEquipment}
                    onChange={() => {
                      handleChange({ rescueOptionsEvacuationAndSafetEquipment: !props.rescuePlanPageTwo.rescueOptionsEvacuationAndSafetEquipment });
                    }} />
                  <label>Evakuering-/räddningsutrustning</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Col>
      <div className='mt-3 bottomborderRecuePlan' />
      <Row xs={12} lg={3} className='mt-3 mx-5 mb-3'>
        <p className="fw-bold fs-5 d-flex align-items-center">Räddningstjänst telnr: 112</p>
        <LabelAndTextBox title="Antal minuter tills räddningstjänsten kan vara på plats" remark={props.rescuePlanPageTwo?.minutesUntilRescueServiceCanArrive}
          onChange={(value) => {
            handleChange({ minutesUntilRescueServiceCanArrive: value });
          }} />
        <LabelAndTextBox title="Alla deltagare i det riskfyllda arbetet ska namnges" remark={props.rescuePlanPageTwo?.riskyWorkParticipants}
          onChange={(value) => {
            handleChange({ riskyWorkParticipants: value });
          }} />
      </Row>
      <div className=''>
        <h4 className='fw-bold'>Delgives</h4>
        <p className="rescuePlanInfoBox fs-5 p-2">Delgives dem som inte varit med vid framtagandet av riskanalysen
          Samtliga som tar del av projektdok. delges via QRkod </p>
        <Row xs={12} lg={3} className='mt-3 mx-5 mb-3'>
          <LabelAndTextBox title="Ort och datum" remark={props.rescuePlanPageTwo?.establishedByCityAndDate}
            onChange={(value) => {
              handleChange({ establishedByCityAndDate: value });
            }} />
          <LabelAndTextBox title="Namnteckning" remark={props.rescuePlanPageTwo?.signature}
            onChange={(value) => {
              handleChange({ signature: value });
            }} />
          <LabelAndTextBox onChange={(value) => handleChange({ nameClarification: value })} title="Namnförtydligande" remark={props.rescuePlanPageTwo?.nameClarification} />
        </Row>
        <p className="rescuePlanInfoBox fs-5 p-2">Enligt SS-EN 363 (senaste utgåva) bör ett räddningssystem vara utformat så att en räddning kan genomföras utan att linor behöver kapas.
          Vid arbete på hög höjd ska riskbedömning och planering säkerställa effektiv evakuering och omhändertagande av nödställda personer, inklusive en räddningsplan som är anpassad till arbetet och utrustningen (se Arbetsmiljöverkets grundläggande regler om systematiskt arbetsmiljöarbete och om planering och organisering av arbetsmiljöarbete, AFS 2023:1 och AFS 2023:2).
          Vid byggnads- och anläggningsarbete ska dessutom de grundläggande skyldigheterna för byggherrar, projektörer och byggarbetsmiljösamordnare beaktas (AFS 2023:3).
          Fallrisker ska förebyggas utifrån riskbedömningen, med gemensamma skyddsåtgärder i första hand och personlig fallskyddsutrustning när andra lösningar inte är möjliga eller lämpliga (se AFS 2023:13 Risker vid vissa typer av arbeten).
          För användning av arbetsutrustning ska arbetsgivaren säkerställa att den som använder utrustningen har tillräckliga praktiska och teoretiska kunskaper för säker användning och att detta vid behov kan styrkas med dokumentation på arbetsstället (se AFS 2023:11 Arbetsutrustning och personlig skyddsutrustning – säker användning).
          Fallskyddsåtgärder ska bestämmas utifrån dokumenterad riskbedömning av fallrisk (risk att falla till lägre nivå och skadas) och arbetsförhållanden; en angiven fallhöjd är inte ensamt styrande. Fallrisk ska i första hand förebyggas genom att arbetet planeras/utformas så att fallrisk elimineras eller begränsas med kollektiva skyddsåtgärder. Personlig fallskyddsutrustning ska användas när andra åtgärder inte är möjliga eller inte ger tillräckligt skydd, och ska då kombineras med planerade rutiner och resurser för snabb räddning/evakuering. (Se AFS 2023:13.) </p>
      </div>
    </Container>
  )
}

export default RescuePlanPageTwoSection;